import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Landscaper } from '../_interfaces/landscaper';

@Injectable({
  providedIn: 'root'
})
export class LandscaperService {

  constructor(private http: HttpClient) { }

  getLandscapers(params: {pageIndex : number, pageSize :number, selectedStatus: string, keyword?: string, sort?: string}): Observable<Landscaper[]> {
    const data =  this.http.post<Landscaper[]>('/store',params );
    return data;
  }

  createEditLandscraper(landscraper: Landscaper, type : string): Observable<Landscaper>  {
    const data = this.http.post<Landscaper> (type == 'EDIT' ?  '/store/update' : '/store/create', landscraper);
    return data;
  }

  approveLandscraper(landscraper: Landscaper): Observable<Landscaper>  {
    const data = this.http.put<Landscaper> ( '/store/approve' , landscraper);
    return data;
  }

  // The create / update / approve endpoints report success by throwing an
  // HTTP error whose message says "...successfully!!" (the public website's
  // sign-up form depends on that), so a "failure" carrying that message is a
  // success.
  static succeeded(error: any): boolean {
    return /successfully/i.test(String(error?.error?.message ?? ''));
  }

  deleteLandscaper(storeId: number): Observable<any> {
    return this.http.post<any>('/store/delete', { storeId });
  }

}
